import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams, ModalController, Events, Content } from 'ionic-angular';
import { TrophyComponent } from '../../../../components/trophy/trophy';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { ResultListModel, ResultProvider, TrophyColor, TrophyMaterial, TrophyType } from '../../../../providers/result/result';
import { SharingProvider } from '../../../../providers/sharing/sharing';
import { UserProvider } from '../../../../providers/user/user';
import { ResultCreatePagerPage } from '../../../results/result-create-pager/result-create-pager';
import { ResultEditTrophyPage } from '../../../results/result-edit-trophy/result-edit-trophy';
import { Pager, EventDetailsModel, EventProvider } from '../../../../providers/event/event';
import { MysportResultsMenuPage } from './mysport-results-menu/mysport-relults-menu';
import { EventTabsPage } from '../../../event/details/event-tabs/event-tabs';
import { ConfigProvider } from '../../../../providers/config/config';
import { ActiveResult } from '../../../results/result-add/result-add';
import { TakeSelfiePage } from './mysport-results-menu/take-selfie/take-selfie';
import { SocialSharing } from '@ionic-native/social-sharing';
import { eventCategories } from '../../../../assets/data/categories/categories';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { ResultDetailsCommentPage } from '../../../results/result-details/result-details-comment/result-details-comment';
import { ResultDetailsThumbupPage } from '../../../results/result-details/result-details-thumbup/result-details-thumbup';

/**
 * Generated class for the MysportResultsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-mysport-results',
  templateUrl: 'mysport-results.html'
})
export class MysportResultsPage {
  results: ResultListModel[] = [];
  selectedResult?: number = null;

  init: boolean = false;

  comments: any = [];
  congrats: any = [];

  @ViewChild('trophy')
  trophyComponent: TrophyComponent;

  clientHannover: boolean = false;
  clientHella: boolean = false;


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    public translate: TranslateService,
    public resultService: ResultProvider,
    public loadingCtrl: LoaderProvider,
    private sharingService: SharingProvider,
    private userService: UserProvider,
    private sharer: SocialSharing,
    private iab: InAppBrowser,
    private modalCtrl: ModalController,
    private eventsListener: Events,
    private eventService: EventProvider,
    private config: ConfigProvider
  ) {
    new Promise<any>(async (resolve, reject) => {
      this.results = navParams.data.results;
      let activeResult: ActiveResult = this.navParams.get('activeResult');
      this.eventsListener.unsubscribe('fan:update');

      this.clientHannover = this.clientHella = (await this.config.config).showHide.liveResults;

      if (this.results.length !== 0) {
        this.selectedResult = 0;

        if (activeResult) {
          for (let i = 0; i < this.results.length; i++) {
            if (this.results[i].eventId == activeResult.eventId && this.results[i].gtime == activeResult.time) {
              this.selectedResult = i;
              return;
            }
          }
        }

      }
    });
  }

  reload() {
    this.init = false;
    setTimeout(() => {
      this.init = true
    });
  }

  getComments(): Promise<boolean> {
    console.log('this.results: ', this.results);
    if (this.results.length <= 0) return;
    return new Promise<boolean>((resolve, reject) => {
      this.resultService.getComments(this.results[this.selectedResult].id, null, null, null).then(data => {
        this.comments = data;
        console.log('data: ', data);
        resolve(null);
      });
    });
  }

  onResultsRedirect() {
    this.navCtrl.popToRoot();
    if (this.clientHannover || this.clientHella) this.app.getRootNav().getActiveChildNav().select(2);
    else this.app.getRootNav().getActiveChildNav().select(1);
  }

  getCongrats(): Promise<boolean> {
    if (this.results.length <= 0) return;
    return new Promise<boolean>((resolve, reject) => {
      this.resultService.getFans(this.results[this.selectedResult].id, null, null, null).then(data => {
        this.congrats = data;
        resolve(data);
      });
    });
  }


  preloadData() {
    // comments and congrats numbers preload
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    Promise.all([this.getComments(), this.getCongrats()]).then((data) => {

      this.comments = data[0];
      console.log('comments: ', this.comments);
      this.congrats = data[1];
      console.log('this.congrats: ', this.congrats);

      this.eventsListener.publish('fan:update');

      this.reload();

      loader.dismiss()
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MysportResultsPage');
  }

  showMysportAdd() {
    this.app.getRootNav().push(ResultCreatePagerPage);
  }

  prev() {
    console.log('prev');
    this.selectedResult--;
    this.trophyComponent.switch(this.results[this.selectedResult]);
    // this.preloadData();
  }

  next() {
    console.log('next');
    this.selectedResult++;
    this.trophyComponent.switch(this.results[this.selectedResult]);
    // this.preloadData();
  }

  ionViewWillLeave() {
    if (typeof this.trophyComponent !== "undefined")
      this.trophyComponent.ionViewWillLeave();

    this.eventsListener.unsubscribe('fan:update');
  }

  ionViewWillEnter() {
    if (typeof this.trophyComponent !== "undefined")
      this.trophyComponent.ngAfterViewInit();

    // this.preloadData();
  }

  // swiped(e) {
  //   switch (e.offsetDirection) {
  //     case 2:
  //       if (this.results && this.selectedResult < this.results.length - 1) {
  //         this.next();
  //       }
  //       // console.log("right to left");
  //       break;
  //     case 4:
  //       if (this.selectedResult > 0) {
  //         this.prev();
  //       }
  //       // console.log("left to right");
  //       break;
  //     default:
  //       // console.log("magic");
  //       break;
  //   }
  // }

  showConfigurator() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    Promise.all([
      this.resultService.getTrophyType(),
      this.resultService.getTrophyColor(),
      this.resultService.getTrophyMaterial()
    ]).then(datas => {
      this.navCtrl
        .push(ResultEditTrophyPage, {
          data: {
            result: this.results[this.selectedResult],
            types: datas[0],
            colors: datas[1],
            materials: datas[2]
          }
        })
        .then(() => loader.dismiss());
    });
  }


  openEventDetails() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    this.eventService.getEventDetails(this.results[this.selectedResult].eventId).then((event: EventDetailsModel) => {

      if (event.name.length < 1) {
        this.openEventDetails();
        loader.dismiss();
      } else {
        (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
      }
    });
  }

  share() {
    this.sharer.shareViaFacebook('', null, "https://spooorts.de/ui/showTrophy.jsf?id=" + this.trophyComponent.result.id);

    // this.sharingService.share(
    //   '/ui/showTrophyPublicMe.jsf?mo=pub&id=' +
    //   this.trophyComponent.result.athleteId +
    //   '&resultId=' +
    //   this.trophyComponent.result.id +
    //   '&current=' +
    //   new Date().getTime()
    // );
  }

  showMenu() {
    const modal = this.modalCtrl.create(MysportResultsMenuPage, { mode: 'private' });
    modal.onDidDismiss(option => {
      console.log(option);
      this.modalPerform(option);
    })
    modal.present();
  }

  modalPerform(option: string) {
    if (option == "add_results") {
      this.showMysportAdd();
    } else if (option == "add_friend") {
      this.userService.addFriend(this.results[this.selectedResult].athleteId)
        .then(res => console.log('the friend is added.'))
        .catch(err => console.log('the friend was not added'));
    } else if (option == "comment") {
      this.navCtrl.push(ResultDetailsCommentPage, { result: this.results[this.selectedResult].id });
    } else if (option == "congrat") {
      this.navCtrl.push(ResultDetailsThumbupPage, { result: this.results[this.selectedResult].id });
    } else if (option == "configure") {
      this.showConfigurator();
    } else if (option == "fb_post") {
      this.showSelfiePage();
    } else if (option == "instagram_post") {
      this.showSelfiePage();
    } else if (option == "finisher_shirt") {
      this.shopRedirect();
    } else if (option == "selfie") {
      this.showSelfiePage();
    } else if (option == "show_trophy") {
      const url = `https://spooorts.de/ui/showTrophy.jsf?id=${this.results[this.selectedResult].id}`;
      let browser = this.iab.create(url, "_system", { hardwareback: 'yes' });
      browser.show();
    } else if (option == "show_award_ceremondy") {
      const url = `https://spooorts.de/ui/showTrophyPremier.jsf?id=${this.results[this.selectedResult].id}`;
      let browser = this.iab.create(url, "_system", { hardwareback: 'yes' });
      browser.show();
    }
  }

  shopRedirect() {
    window.location.href = "http://spooorts.shop";
  }

  showSelfiePage() {
    const categoryIndex = eventCategories.findIndex(c => c.id == this.results[this.selectedResult].cid);
    let category = "";
    if (categoryIndex > -1) {
      category = eventCategories[categoryIndex].name;
    }

    let eventDate = (this.translate.getDefaultLang().toUpperCase().includes("DE"))
      ? new Date(this.results[this.selectedResult].eventDate).toISOString().substr(0, 10).split('-').reverse().join('.')
      : new Date(this.results[this.selectedResult].eventDate).toISOString().substr(0, 10);

    let resultDetails = {
      distance: this.results[this.selectedResult].streckeconv,
      time: new Date(this.results[this.selectedResult].gtime * 1000).toISOString().substr(11, 8),
      place: this.results[this.selectedResult].gplatz + ". " + this.translate.instant("RESULT_CREATE_LABEL_PLACE"),
      eventDate: eventDate,
      eventName: this.results[this.selectedResult].eventName,
      cid: category,
      logo: "assets/imgs/goforest/white.png"
    }

    this.navCtrl.push(TakeSelfiePage, { resultDetails: resultDetails });
  }

}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-results/mysport-results.ts